// extracted by mini-css-extract-plugin
export var alignBaseline = "_15-9";
export var alignCenter = "_15-5";
export var alignFlexEnd = "_15-7";
export var alignFlexStart = "_15-6";
export var alignSelfBaseline = "_15-e";
export var alignSelfCenter = "_15-a";
export var alignSelfFlexEnd = "_15-c";
export var alignSelfFlexStart = "_15-b";
export var alignSelfStretch = "_15-d";
export var alignStretch = "_15-8";
export var column = "_15-2";
export var columnReverse = "_15-4";
export var flex = "_15-0";
export var justifyCenter = "_15-f";
export var justifyFlexEnd = "_15-h";
export var justifyFlexStart = "_15-g";
export var justifySpaceAround = "_15-j";
export var justifySpaceBetween = "_15-i";
export var justifySpaceEvenly = "_15-k";
export var row = "_15-1";
export var rowReverse = "_15-3";
export var wrapNowrap = "_15-m";
export var wrapWrap = "_15-l";
export var wrapWrapReverse = "_15-n";